// extracted by mini-css-extract-plugin
export default {"columnTitle":"PagesTable_columnTitle__kYbnj"};